import { FC, ReactNode } from 'react'

import { Card, Typography } from '@mui/material'

interface EmptyStateCardProps {
  /** The reason there is nothing to show. */
  children: ReactNode
}

/**
 * Centred outlined card explaining why a section has nothing to render.
 *
 * Distinct from `UAInsightsErrorState`: this is for a legitimately empty
 * result (a game with no tracked story patterns, say), which the user cannot
 * fix by retrying.
 */
export const EmptyStateCard: FC<EmptyStateCardProps> = ({ children }) => (
  <Card variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
    <Typography sx={{ color: 'text.secondary' }}>{children}</Typography>
  </Card>
)
